/**
 * Environment-aware debug logging utility.
 * Drop-in replacement for console.log that only outputs in development.
 * Errors always log regardless of environment.
 *
 * Usage:
 *   import { debug } from '@/utils/debug';
 *   debug.log('fetched data', data);
 *   debug.warn('missing field', field);
 *   debug.error('failed to load', err);  // always logs
 */

const isDev = import.meta.env.DEV;

export const debug = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args); // eslint-disable-line no-console
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args); // eslint-disable-line no-console
  },
  error: (...args: unknown[]) => {
    console.error(...args); // eslint-disable-line no-console
  },
  group: (label: string) => {
    if (isDev) console.group(label); // eslint-disable-line no-console
  },
  groupEnd: () => {
    if (isDev) console.groupEnd(); // eslint-disable-line no-console
  },
};
